import { useMemo } from 'react';
import { useInterviewRecordOptions } from './useInterviewRecordOptions';
import { FALLBACK_FOLLOW_SPEC, followSpecFrom, type FollowSpec } from '../utils/followStatus';

/**
 * フォロー状況の 4 値と遷移の表（課題 #71 / BE PR #143）。
 * options API から受け取る。無い・読めないときは FE の表を使う（表示と送信を止めない。
 * 遷移は BE が 409 で守るため、FE の表が古くても権限や記録を越えることはない）。
 */
export function useFollowSpec(): FollowSpec {
  const state = useInterviewRecordOptions();
  return useMemo(
    () => (state.status === 'ready' ? followSpecFrom(state.options) : FALLBACK_FOLLOW_SPEC),
    [state]
  );
}
